import { atom } from "jotai";

export interface AppBarSticky {
  appBarHeight: number;
  stickyHeight: number;
}

export const appBarStickyAtom = atom<AppBarSticky>({
  appBarHeight: 0,
  stickyHeight: 0,
});

export interface AppBarScrollSticky {
  stickyScrollHeight: number;
}

export const appBarScrollStickyAtom = atom<AppBarScrollSticky>({
  stickyScrollHeight: 0,
});

/**
 * Height of a fixed-position header that stays on screen while the app bar container itself is
 * translated out of the viewport (e.g. the home mini header). 0 when there is no such header.
 */
export const appBarFixedHeaderHeightAtom = atom(0);
